import { HeadersRoutes } from '../HeaderOptions';
import './NavMenu.css';
import NavMenuOption from './navMenuItem/NavMenuOption';
import useSocketClientStatus from '../../hooks/useSocketClientStatus';
import useSocketClientInfo from '../../hooks/useSocketClientInfo';
import { useHeaderOptions } from '../../hooks/useHeaderOptions';
import { Avatar } from './avatar/Avatar';
import { CurrentUser } from '../../login/CurrentUser';
import DateUtils from '../../../utils/DateUtils';
import Navigator from '../../../utils/Navigator';
import { MessageDialog } from '../../messagebox/MessageBox';


export interface INavMenuProps {
    Show: boolean
}

export default function NavMenu(props: INavMenuProps) {

    const status = useSocketClientStatus();
    const machineInfo = useSocketClientInfo();
    const options = useHeaderOptions();
    return (
        <div className='NavMenu' style={props.Show ? { display: 'flex' } : { display: 'none' }}>

            <div className='MeusDadosNavContainer'>
                
                <div className='MeusDadosUserNavItem'>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'start', width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start', gap: '10px' }}>
                            <Avatar name="Adriano M. Balera" />
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'start', gap: '0px' }}>
                                <h3>{CurrentUser.User?.Name!}</h3>
                                <p>Perfil: Administrador</p>
                                <p>Ultimo acesso: { CurrentUser.User?.LastLogin ? DateUtils.CastDateWithTimeToString(new Date(CurrentUser.User!.LastLogin!)) : "Sem registro" }</p>                               
                            </div>
                        </div>
                        
                         <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'space-around', width: '100%', borderTop: '1px solid var(--user-infos-background-separator)', marginTop: '5px', paddingTop: '3px' }}>

                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', gap: '5px', cursor: 'pointer' }} onClick={()=> Navigator.NavigateTo('info')}>
                                        <i className="nav-icon pi pi-cog" style={{fontSize: '15px'}} ></i><p>Configurações</p>
                                    </div>

                                    <div style={{borderLeft: '1px solid var(--user-infos-background-separator)', marginTop: '3px', height: '15px'}}>&nbsp;</div>

                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', gap: '5px', cursor: 'pointer' }} onClick={()=> {
                                        MessageDialog.Show({
                                                                    Message: "Deseja sair e voltar para tela de Login?",
                                                                    OKText: "Sair",
                                                                    Canceltext: "Cancelar",
                                                                    Title: "Atenção",
                                                                    OKClickEvent: CurrentUser.LogOff,
                                                                    IsOpen: true
                                                                });
                                    }}>
                                        <i className="nav-icon pi pi-sign-out" style={{fontSize: '15px'}}></i><p>Sair do App</p>
                                    </div>
                                    
                                </div>
                    </div>


                </div>
            </div>

            <div className='NavItensContainer'>
                {
                    options.Select(s => (
                        <NavMenuOption
                            Image={s.Image}
                            Title={s.Title}
                            SubTitle={s.SubTitle}
                            URL={s.URL}
                            key={s.URL}
                            Help={s.Help} />
                    ))
                }
            </div>

            <div style={{ width: '100%' }}>
                {

                    <>
                        <code>Status:</code> <code className={status ? "CodeOnline" : "CodeOffline"}>{status ? "Online" : "Offline"}</code>
                        <br />
                        <code>DOC-Windows:</code> <code className={status ? "CodeOnline" : "CodeOffline"}>{machineInfo.Machine && status ? machineInfo.Machine : "Offline"}</code>
                        <br />
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                            <div><code>DOC-Mobile:</code> <code className={status ? "CodeOnline" : "CodeOffline"}>{process.env.REACT_APP_VERSION}</code></div>                            
                        </div>


                    </>

                }
            </div>

        </div>
    )
}